import { PropsWithChildren, ReactNode } from 'react';

import { cn } from '@/utils/cn';

type Props = PropsWithChildren & {
    className?: string;
    header?: ReactNode;
    title?: string;
    variant: 'top' | 'aside';
};

export const SectionDescription = ({
    children,
    className,
    header,
    title,
    variant,
}: Props) => (
    <div
        className={cn(
            'flex flex-col gap-4',
            {
                'lg:w-[520px]': variant === 'aside',
                'pb-10': variant === 'aside',
            },
            className,
        )}
    >
        {title && (
            <h2
                className={cn(
                    `typography-sub-heading text-pretty pb-0 uppercase`,
                    {
                        'text-center': variant === 'top',
                    },
                )}
            >
                {title}
            </h2>
        )}
        {header && (
            <h3
                className={cn('text-pretty font-bold -tracking-wider', {
                    'text-[40px] leading-none sm:text-6xl': variant === 'aside',
                    'text-center text-[40px] leading-none sm:text-[88px]':
                        variant === 'top',
                })}
            >
                {header}
            </h3>
        )}
        {children !== undefined && (
            <div
                className={cn(
                    `
                      mt-2 flex flex-col gap-4

                      [&_p]:typography-body1
                    `,
                    { 'text-center': variant === 'top' },
                )}
            >
                {children}
            </div>
        )}
    </div>
);
